var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id)?_c('div',[_c('div',{staticClass:"lottie",style:({width: _vm.width + 'px', height: _vm.height + 'px'}),attrs:{"id":_vm.id}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }